import { MutationTree } from 'vuex'
import { UserState } from './user.types'
import { User } from '../../types'

export enum MutationTypes {
  SET_USER = 'SET_USER',
  SET_USER_ERROR = 'SET_USER_ERROR',
  SET_USER_LOADING = 'SET_USER_LOADING'
}

export const mutations: MutationTree<UserState> = {
  [MutationTypes.SET_USER](state, user: User) {
    state.user = Object.assign({}, user, { company: state.user?.company || user.company })
  },
  [MutationTypes.SET_USER_ERROR](state, error) {
    state.userError = error
  },
  [MutationTypes.SET_USER_LOADING](state, val: boolean) {
    state.loading = val
  }
}
